<template>
    <div>
    <div style="padding: 24px 16px 8px 16px; text-align: right;"">
                <span style="font-size: 10px;">Made with DentiCalc</span>
            </div>

            <div style="text-align: justify; padding: 8px 16px; font-size: 10px;"">
                <p v-html="$t('send_email.content_part_08')"></p>
                <p v-html="$t('send_email.content_part_09', { companyName: 'PlanMaster Fogászati Szoftver Kft.'})"></p>
                <p v-html="$options.filters.capitalize($t('send_email.content_part_10', { dentistName: $t('send_email.your-dentist'), companyName: 'PlanMaster Fogászati Szoftver Kft.'}))"></p>
            </div>
            </div>
</template>
<script>
export default {
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>
